import { gql } from 'src/__generated__';

export const CREATE_LINKOUT_APPLICATION = gql(`
mutation createApplyLinkout($jobId: ID!) {
  createLinkoutApplication(input: { jobId: $jobId }) {
    applicationUrl
  }
}
`);
